import { useState, useEffect } from 'react';
import {
  Divider,
  Card,
  CardHeader,
  Container,
  Grid,
  Tab,
  Box,
} from '@mui/material';
import axios from 'axios';
import { url } from 'src/Helpers/utils/Constant';
import { ICivilAviationList } from 'src/Types/module/UpdateRequest/RequestCivilAviation';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import CivilAviationIndex from './CivilAviationIndex';

const RequestCivilAviationInfo = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [civilAviationInfo, setCivilAviationInfo] = useState<
    ICivilAviationList[]
  >([]);
  const [value, setValue] = useState('pending');

  useEffect(() => {
    setIsLoading(true);
    try {
      (async function () {
        const { data } = await axios.get(
          `${url}/api/atab/member-company/update-request/civil/aviation?status=${value}`
        );

        if (data.success) {
          setCivilAviationInfo(data.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })();
    } catch (error) {
      setIsLoading(false);
    }
  }, [value]);

  return (
    <Container sx={{ mt: 4 }} maxWidth='xl'>
      <Grid
        container
        direction='row'
        justifyContent='center'
        alignItems='stretch'
        spacing={3}
      >
        <Grid item xs={12}>
          <TabContext value={value}>
            <Card>
              <CardHeader
                title='Civil aviation information'
                action={
                  <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderColor: 'divider' }}>
                      <TabList
                        onChange={(_event, newValue) => setValue(newValue)}
                        aria-label='lab API tabs example'
                      >
                        <Tab label='Pending' value='pending' />
                        <Tab label='Approved' value='approved' />
                        <Tab label='Rejected' value='rejected' />
                      </TabList>
                    </Box>
                  </Box>
                }
              />
              <Divider />
              <TabPanel value='pending'>
                <CivilAviationIndex
                  isLoading={isLoading}
                  civilAviationInfo={civilAviationInfo}
                />
              </TabPanel>
              <TabPanel value='approved'>
                <CivilAviationIndex
                  isLoading={isLoading}
                  civilAviationInfo={civilAviationInfo}
                />
              </TabPanel>
              <TabPanel value='rejected'>
                <CivilAviationIndex
                  isLoading={isLoading}
                  civilAviationInfo={civilAviationInfo}
                />
              </TabPanel>
              {/* <Box p={2}>
              <TablePagination
                component='div'
                count={companyInfo?.length}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={page && page}
                rowsPerPage={limit}
                rowsPerPageOptions={[25, 50, 75, 100]}
              />
            </Box> */}
            </Card>
          </TabContext>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RequestCivilAviationInfo;
